<script>
import webApi from './webApi'
import constants from './constants'

export default {
  name: 'Helpers',
  beforeCreate () {
    // https://tc39.github.io/ecma262/#sec-array.prototype.find
    // THIS IS A CODE SNIPPET TO ADD array.find TO THE IE BROWSERS.
    if (!Array.prototype.find) {
      /* eslint no-extend-native: ["error", { "exceptions": ["Array", "Date"] }] */
      Object.defineProperty(Array.prototype, 'find', {
        value: function (predicate) {
          // 1. Let O be ? ToObject(this value).
          if (this == null) {
            throw new TypeError('"this" is null or not defined')
          }

          var o = Object(this)

          // 2. Let len be ? ToLength(? Get(O, "length")).
          var len = o.length >>> 0

          // 3. If IsCallable(predicate) is false, throw a TypeError exception.
          if (typeof predicate !== 'function') {
            throw new TypeError('predicate must be a function')
          }

          // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
          var thisArg = arguments[1]

          // 5. Let k be 0.
          var k = 0

          // 6. Repeat, while k < len
          while (k < len) {
            // a. Let Pk be ! ToString(k).
            // b. Let kValue be ? Get(O, Pk).
            // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
            // d. If testResult is true, return kValue.
            var kValue = o[k]
            if (predicate.call(thisArg, kValue, k, o)) {
              return kValue
            }
            // e. Increase k by 1.
            k++
          }

          // 7. Return undefined.
          return undefined
        }
      })
    }

    // https://tc39.github.io/ecma262/#sec-array.prototype.includes
    if (!Array.prototype.includes) {
      Object.defineProperty(Array.prototype, 'includes', {
        value: function (searchElement, fromIndex) {
          if (this == null) {
            throw new TypeError('"this" is null or not defined')
          }

          // 1. Let O be ? ToObject(this value).
          var o = Object(this)

          // 2. Let len be ? ToLength(? Get(O, "length")).
          var len = o.length >>> 0

          // 3. If len is 0, return false.
          if (len === 0) {
            return false
          }

          // 4. Let n be ? ToInteger(fromIndex).
          //    (If fromIndex is undefined, this step produces the value 0.)
          var n = fromIndex | 0

          // 5. If n ≥ 0, then
          //  a. Let k be n.
          // 6. Else n < 0,
          //  a. Let k be len + n.
          //  b. If k < 0, let k be 0.
          var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0)

          function sameValueZero (x, y) {
            return x === y || (typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y))
          }

          // 7. Repeat, while k < len
          while (k < len) {
            // a. Let elementK be the result of ? Get(O, ! ToString(k)).
            // b. If SameValueZero(searchElement, elementK) is true, return true.
            if (sameValueZero(o[k], searchElement)) {
              return true
            }
            // c. Increase k by 1.
            k++
          }

          // 8. Return false
          return false
        }
      })
    }

    /// Function to add days to a date.
    Date.prototype.addDays = function (days) {
      var dat = new Date(this.valueOf())
      dat.setDate(dat.getDate() + days)
      return dat
    }
  },
  methods: {
    // ************************ Check numeric ******************
    // Check if value is numeric
    isNumeric (n) {
      return !isNaN(parseFloat(n)) && isFinite(n)
    },

    //* ******************* Truncate *****************
    // Returns '' if str === null
    //        str if str.length < length
    //        str.substring(0,length) is str.length > length
    truncate (str, length) {
      if (!str) {
        return ''
      } else {
        return str.substring(0, length)
      }
    },

    // ************************ Download ******************
    // Returns the excel document for the parameter list of columns and values with the parameter filename
    getexcelDownload (excelList, filename) {
      // Call the api and pass the filtered columns and values
      webApi.parcel.download_Parcel_List_XLSX(excelList)
        .then((response) => {
          // From the returned file stream we create a blob

          var blob = new Blob([response.data],
            { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
          )

          // Cypress headless fix
          if (window.Cypress) {
            return
          }

          // Open the blob to be downloaded, for  IE we need  a special way of opening it
          if (window.navigator.msSaveOrOpenBlob) { // IE hack; see http://msdn.microsoft.com/en-us/library/ie/hh779016.aspx
            window.navigator.msSaveBlob(blob, filename)
          } else {
            var a = window.document.createElement('a')
            a.href = window.URL.createObjectURL(blob, { type: 'text/plain' })
            a.download = filename
            document.body.appendChild(a)
            a.click() // IE: "Access is denied"; see: https://connect.microsoft.com/IE/feedback/details/797361/ie-10-treats-blob-url-as-cross-origin-and-denies-access
            document.body.removeChild(a)
          }
        }).catch((response) => {
          window.bus.$emit('openErrorModal', response.data.ExceptionMessage)
        })
    },

    // Returns the excel document for the parameter list of columns and values with the parameter filename
    getExportProofExcelDownload (excelList, filename) {
      // Call the api and pass the filtered columns and values
      webApi.parcel.download_Export_Proof_List_XLSX(excelList)
        .then((response) => {
          // From the returned file stream we create a blob

          var blob = new Blob([response.data],
            { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
          )

          // Cypress headless fix
          if (window.Cypress) {
            return
          }

          // Open the blob to be downloaded, for  IE we need  a special way of opening it
          if (window.navigator.msSaveOrOpenBlob) { // IE hack; see http://msdn.microsoft.com/en-us/library/ie/hh779016.aspx
            window.navigator.msSaveBlob(blob, filename)
          } else {
            var a = window.document.createElement('a')
            a.href = window.URL.createObjectURL(blob, { type: 'text/plain' })
            a.download = filename
            document.body.appendChild(a)
            a.click() // IE: "Access is denied"; see: https://connect.microsoft.com/IE/feedback/details/797361/ie-10-treats-blob-url-as-cross-origin-and-denies-access
            document.body.removeChild(a)
          }
        }).catch((response) => {
          window.bus.$emit('openErrorModal', response.data.ExceptionMessage)
        })
    },

    sendExportProofEmail (pdfList, language) {
      // Call the api and pass the filtered columns and values
      webApi.exportProof.send_Export_Proof_Email(pdfList, 'Email', language)
        .then((response) => {
          window.bus.$emit('openSuccessModal', 'Email sent succesfully!')
        }).catch((response) => {
          window.bus.$emit('openErrorModal', response)
        })
    },

    // Returns the pdf document for the parameter list of columns and values with the parameter filename
    getExportProofPDFDownload (pdfList, filename) {
      // Call the api and pass the filtered columns and values
      webApi.exportProof.download_Export_Proof_List_PDF(pdfList)
        .then((response) => {
          // From the returned file stream we create a blob

          var arrayData = this.base64ToArrayBuffer(response.data)

          var blob = new Blob([arrayData],
            { type: 'application/pdf' }
          )

          // Cypress headless fix
          if (window.Cypress) {
            return
          }

          // Open the blob to be downloaded, for  IE we need  a special way of opening it
          if (window.navigator.msSaveOrOpenBlob) { // IE hack; see http://msdn.microsoft.com/en-us/library/ie/hh779016.aspx
            window.navigator.saveAs(blob, filename)
          } else {
            var a = window.document.createElement('a')
            a.href = window.URL.createObjectURL(blob, { type: 'text/plain' })
            a.download = filename
            document.body.appendChild(a)
            a.click() // IE: "Access is denied"; see: https://connect.microsoft.com/IE/feedback/details/797361/ie-10-treats-blob-url-as-cross-origin-and-denies-access
            document.body.removeChild(a)
          }
        }).catch((response) => {
          window.bus.$emit('openErrorModal', response)
        })
    },
    // Returns the pdf document for the parameter list of columns and values with the parameter filename
    generateManifestDocument (dailyCargodata, filename, documentName) {
      var result = -1
      var webAPI = null
      switch (documentName) {
        case 'summary':
          webAPI = webApi.daily_cargo.download_Summary_PDF(dailyCargodata)
          break
        case 'identity':
          webAPI = webApi.daily_cargo.download_Identity_Check_Sheet(dailyCargodata)
          break
        default:
          webAPI = webApi.daily_cargo.download_Manifest_PDF_New(dailyCargodata)
          break
      }
      // Call the api and pass the filtered columns and values
      webAPI
        .then((response) => {
          // From the returned file stream we create a blob
          var arrayData = this.base64ToArrayBuffer(response.data)

          var blob = new Blob([arrayData],
            { type: 'application/pdf' }
          )

          // Cypress headless fix
          if (window.Cypress) {
            return
          }

          // Open the blob to be downloaded, for  IE we need  a special way of opening it
          if (window.navigator.msSaveOrOpenBlob) { // IE hack; see http://msdn.microsoft.com/en-us/library/ie/hh779016.aspx
            window.navigator.saveAs(blob, filename)
          } else {
            var a = window.document.createElement('a')
            a.href = window.URL.createObjectURL(blob, { type: 'text/plain' })
            a.download = filename
            document.body.appendChild(a)
            a.click() // IE: "Access is denied"; see: https://connect.microsoft.com/IE/feedback/details/797361/ie-10-treats-blob-url-as-cross-origin-and-denies-access
            document.body.removeChild(a)
          }
          result = 1
        }).catch((response) => {
          window.bus.$emit('openErrorModal', response)
          result = -1
        })
      return result
    },

    base64ToArrayBuffer (base64) {
      var binaryString = window.atob(base64)
      var binaryLen = binaryString.length
      var bytes = new Uint8Array(binaryLen)
      for (var i = 0; i < binaryLen; i++) {
        var ascii = binaryString.charCodeAt(i)
        bytes[i] = ascii
      }
      return bytes
    },
    // Returns the excel document for the parameter list of columns and values with the parameter filename
    getDownload (context, documentID, fileName) {
      // Call the api and pass the filtered columns and values
      webApi.document.download_Document(documentID)
        .then((response) => {
          this.downloadFile(response, fileName)
        }).catch((response) => {
          window.bus.$emit('openErrorModal', response.data.ExceptionMessage)
        })
    },

    downloadFile (response, fileName, fileType = 'text/plain') {
      // Cypress headless fix
      if (window.Cypress) {
        return
      }
      // From the returned file stream we create a blob
      var blob = new Blob([response.data])
      // Open the blob to be downloaded, for  IE we need  a special way of opening it
      if (window.navigator.msSaveOrOpenBlob) { // IE hack; see http://msdn.microsoft.com/en-us/library/ie/hh779016.aspx
        window.navigator.msSaveBlob(blob, fileName)
      } else {
        var a = window.document.createElement('a')
        a.href = window.URL.createObjectURL(blob, { type: 'text/plain' })
        a.download = fileName
        document.body.appendChild(a)
        a.click() // IE: "Access is denied"; see: https://connect.microsoft.com/IE/feedback/details/797361/ie-10-treats-blob-url-as-cross-origin-and-denies-access
        document.body.removeChild(a)
      }
    },

    // ************************ Number Format Helper ******************
    numberFormat (num, digitsAfterDecimalPoint, hideTrailingZeros) {
      var bits = []
      var wholeNumber = ''
      var decimalNumber = 0

      num = num || 0

      // Replace decimal comma with decimal period
      num = num.toString().replace(',', '.')

      // Split number into whole number and decimal part
      if (num.indexOf('.') > -1) {
        // Limit the digits after the decimal point
        if (typeof digitsAfterDecimalPoint !== 'undefined') {
          num = String(Number(num).toFixed(digitsAfterDecimalPoint))
        }
        bits = num.split('.')
        wholeNumber = bits[0]
        decimalNumber = bits[1]
      } else {
        wholeNumber = num
      }

      // Remove any remaining non numeric stuff
      wholeNumber = wholeNumber.replace(/\D-/g, '')

      var len = wholeNumber.length
      if (len > 6) {
        wholeNumber = wholeNumber.substr(0, len - 6) + '.' + wholeNumber.substr(-6, 3) + '.' + wholeNumber.substr(-3)
      } else if (len > 3) {
        wholeNumber = wholeNumber.substr(0, len - 3) + '.' + wholeNumber.substr(-3)
      }

      if (hideTrailingZeros) {
        decimalNumber = String(Number('0.' + decimalNumber)).substr(2)
      }
      return wholeNumber + (decimalNumber > 0 ? '.' + decimalNumber : '')
    },

    // ************************ Date Formats *****************
    formatDate (value, includeTime, dateFormatting) {
      if (value === '' || value == null) {
        return ''
      }
      var moment = require('moment')
      var date = moment(value)
      if (date.year() === 1) {
        return ''
      }
      return date.format(dateFormatting)
    },

    // ************************ Convert hour in days, hours, minutes (Used for deadlines) *****************
    convertMinutes (hour, minute) {
      var day = Math.floor(hour/24)
      var Remainder = hour % 24
      var hours = Math.floor(Remainder)
      var minutes = Math.floor(60 * (Remainder - hours))
      minute = Number(minute)
      minutes = minutes + minute

      if (day > 0) {
        return (day + 1 + ',' + hours + ',' + minutes)
      } else {
        return ('1,' + hours + ',' + minutes)
      }
    },

    // ************************ Add 0 in front of single number. Used for time format *****************
    leftPad (sourceNumber, length, fillCharacter='0') {
      length = length - sourceNumber.toString().length + 1
      if (length > 0) {
        sourceNumber = new Array(length).join(fillCharacter) + sourceNumber
      }
      return sourceNumber
    },

    // ************************ For each method to handle the querySelectorAll result ******************
    foreach_selectorall (array, callback, scope) {
      for (var i = 0; i < array.length; i++) {
        callback.call(scope, i, array[i]) // passes back stuff we need
      }
    },
    // ************************ Clone array ******************
    cloneArray (array) {
      return JSON.parse(JSON.stringify(array))
    },

    // ************************ UC first ******************
    ucFirst (str) {
      str = String(str)
      return str.charAt(0).toUpperCase() + str.slice(1)
    },

    // ************************ Set cookie ******************
    setCookie (cname, cvalue, exdays) {
      var d = new Date()
      d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000))
      var expires = 'expires=' + d.toUTCString()
      document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/'
    },

    // ************************ Get cookie ******************
    getCookie (cname) {
      var name = cname + '='
      var ca = document.cookie.split(';')
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i]
        while (c.charAt(0) === ' ') {
          c = c.substring(1)
        }
        if (c.indexOf(name) === 0) {
          return c.substring(name.length, c.length)
        }
      }
      return ''
    },
    // ************************ Adds the filter options to the URL. ******************
    update_URL: function (route, filterModel) {
      // Create the filter options needed in the parcel list
      var customerIds = '-1'
      var countryIds = '-1'
      var providerIds = '-1'
      var tagIds = '-1'
      var currentEventInfos = '-1'
      var serviceLevelIds = '-1'
      var parcelStatusIds = '-1'
      var fromPostalCode = '-1'
      var toPostalCode = '-1'

      if (filterModel.Customers && filterModel.Customers.length > 0) {
        customerIds = filterModel.Customers.toString()
      }

      if (filterModel.Countries && filterModel.Countries.length > 0) {
        countryIds = filterModel.Countries.toString()
      }

      if (filterModel.Providers && filterModel.Providers.length > 0) {
        providerIds = filterModel.Providers.toString()
      }

      if (filterModel.Tags && filterModel.Tags.length > 0) {
        tagIds = filterModel.Tags.toString()
      }

      if (filterModel.Current_Event_Infos && filterModel.Current_Event_Infos.length > 0) {
        currentEventInfos = filterModel.Current_Event_Infos.toString()
      }

      if (filterModel.Service_Levels && filterModel.Service_Levels.length > 0) {
        serviceLevelIds = filterModel.Service_Levels.toString()
      }

      if (filterModel.Parcel_Status && filterModel.Parcel_Status.length > 0) {
        parcelStatusIds = filterModel.Parcel_Status.toString()
      }

      if (filterModel.From_Postal_Code) {
        fromPostalCode = filterModel.From_Postal_Code
      }

      if (filterModel.To_Postal_Code) {
        toPostalCode = filterModel.To_Postal_Code
      }

      var selectedOptions = {
        from_date: filterModel.From_Date,
        to_date: filterModel.To_Date,
        customer_id: customerIds,
        country_id: countryIds,
        providers: providerIds,
        tags: tagIds,
        service_level_id: serviceLevelIds,
        status: parcelStatusIds,
        current_event_infos: currentEventInfos,
        show_forward_flow: filterModel.Show_Forward_Flow,
        from_postal_code: fromPostalCode,
        to_postal_code: toPostalCode
      }
      this.$router.replace({ name: route, params: selectedOptions })
    },
    /**
     * Gets the link to the signature image for certain partners
     */
    getExternalSignature: function (parcel, constants) {
      if (constants.COUNTRY_ID.FRANCE) {
        if (parcel.Service_Level_ID === constants.SERVICE_LEVEL_ID.PRE_09 ||
                  parcel.Service_Level_ID === constants.SERVICE_LEVEL_ID.PRE_10 ||
                  parcel.Service_Level_ID === constants.SERVICE_LEVEL_ID.PRE_11 ||
                  parcel.Service_Level_ID === constants.SERVICE_LEVEL_ID.PRE_12 ||
                  parcel.Service_Level_ID === constants.SERVICE_LEVEL_ID.PRE_13 ||
                  parcel.Service_Level_ID === constants.SERVICE_LEVEL_ID.SATURDAY_PRE_09 ||
                  parcel.Service_Level_ID === constants.SERVICE_LEVEL_ID.SATURDAY_PRE_10 ||
                  parcel.Service_Level_ID === constants.SERVICE_LEVEL_ID.SATURDAY_PRE_13 ||
                  parcel.Service_Level_ID === constants.SERVICE_LEVEL_ID.CHRONOPOST_LA_POSTE ||
                  parcel.Service_Level_ID === constants.SERVICE_LEVEL_ID.CHRONOPOST_LA_POSTE_SATURDAY ||
                  parcel.Service_Level_ID === constants.SERVICE_LEVEL_ID.CHRONOPOST_PARCEL_SHOP ||
                  parcel.Service_Level_ID === constants.SERVICE_LEVEL_ID.CHRONOPOST_DEPOT ||
                  parcel.Service_Level_ID === constants.SERVICE_LEVEL_ID.CHRONOPOST_DEPOT_SATURDAY ||
                  parcel.Service_Level_ID === constants.SERVICE_LEVEL_ID.PUDO ||
                  parcel.Service_Level_ID === constants.SERVICE_LEVEL_ID.PRE_09_MED ||
                  parcel.Service_Level_ID === constants.SERVICE_LEVEL_ID.PRE_10_MED ||
                  parcel.Service_Level_ID === constants.SERVICE_LEVEL_ID.PRE_11_MED ||
                  parcel.Service_Level_ID === constants.SERVICE_LEVEL_ID.PRE_12_MED ||
                  parcel.Service_Level_ID === constants.SERVICE_LEVEL_ID.PRE_13_MED) {
          var forwarderReference = this.get_Reference_Text(parcel.References, constants.REFERENCE_TYPE_NAME.FORWARDER_REFERENCE)
          if (forwarderReference !== '') {
            return 'http://www.chronotrace.com/showImgWithBg?noLT=' + forwarderReference + '&width=200&height=100'
          } else {
            return null
          }
        }
      }
      return null
    },

    /// Returns the forwarder URL based on the parcel Country, Customer and Service Level.
    getExternalLink: function (parcel, constants) {
      var linkData = {}
      var forwarderReference
      var counterNumber
      if (parcel == null) {
        // No parcel => no link
        return
      }

      if (parcel.Is_Forward === true) {
        // ****************************************** FORWARD PARCELS **************************************************
        switch (parcel.Country_ID) {
          case constants.COUNTRY_ID.FRANCE:
          case constants.COUNTRY_ID.MONACO:
            // *************************************************** FRANCE ******************************************************************
            // France => Chronopost, Ciblex or LM2S
            forwarderReference = this.get_Reference_Text(parcel.References, constants.REFERENCE_TYPE_NAME.FORWARDER_REFERENCE)
            if (forwarderReference === '') {
              linkData.link = ''
              linkData.providerName = ''
            } else if (parcel.Service_Level_ID === constants.SERVICE_LEVEL_ID.PRE_07 ||
                        parcel.Service_Level_ID === constants.SERVICE_LEVEL_ID.PRE_08 ||
                        parcel.Service_Level_ID === constants.SERVICE_LEVEL_ID.PRE_09 ||
                        parcel.Service_Level_ID === constants.SERVICE_LEVEL_ID.PRE_10 ||
                        parcel.Service_Level_ID === constants.SERVICE_LEVEL_ID.PRE_11 ||
                        parcel.Service_Level_ID === constants.SERVICE_LEVEL_ID.PRE_12 ||
                        parcel.Service_Level_ID === constants.SERVICE_LEVEL_ID.PRE_13 ||
                        parcel.Service_Level_ID === constants.SERVICE_LEVEL_ID.SATURDAY_PRE_09 ||
                        parcel.Service_Level_ID === constants.SERVICE_LEVEL_ID.SATURDAY_PRE_10 ||
                        parcel.Service_Level_ID === constants.SERVICE_LEVEL_ID.SATURDAY_PRE_13 ||
                        parcel.Service_Level_ID === constants.SERVICE_LEVEL_ID.CHRONOPOST_LA_POSTE ||
                        parcel.Service_Level_ID === constants.SERVICE_LEVEL_ID.CHRONOPOST_LA_POSTE_SATURDAY ||
                        parcel.Service_Level_ID === constants.SERVICE_LEVEL_ID.CHRONOPOST_PARCEL_SHOP ||
                        parcel.Service_Level_ID === constants.SERVICE_LEVEL_ID.CHRONOPOST_DEPOT ||
                        parcel.Service_Level_ID === constants.SERVICE_LEVEL_ID.CHRONOPOST_DEPOT_SATURDAY ||
                        parcel.Service_Level_ID === constants.SERVICE_LEVEL_ID.PRE_09_MED ||
                        parcel.Service_Level_ID === constants.SERVICE_LEVEL_ID.PRE_10_MED ||
                        parcel.Service_Level_ID === constants.SERVICE_LEVEL_ID.PRE_12_MED ||
                        parcel.Service_Level_ID === constants.SERVICE_LEVEL_ID.PRE_13_MED ||
                        parcel.Service_Level_ID === constants.SERVICE_LEVEL_ID.SATURDAY_PRE_09_MED ||
                        parcel.Service_Level_ID === constants.SERVICE_LEVEL_ID.SATURDAY_PRE_10_MED ||
                        parcel.Service_Level_ID === constants.SERVICE_LEVEL_ID.SATURDAY_PRE_13_MED) {
              // CHRONOPOST
              linkData.link = 'http://www.chronopost.fr/tracking-no-cms/suivi-page?listeNumerosLT=' + forwarderReference + '&langue=en_GB&pod=true'
              linkData.providerName = 'Chronopost'
            } else if (parcel.Service_Level_ID === constants.SERVICE_LEVEL_ID.PUDO_LM2S ||
                      (parcel.Service_Level_ID === constants.SERVICE_LEVEL_ID.STOCKONNECT &&
                        forwarderReference.toString().startsWith('FA'))) {
              /// LM2S
              linkData.link = 'http://lmline.lm2s.fr/pudo/barcode/' + forwarderReference
              linkData.providerName = 'LM2S'
            } else if (parcel.Service_Level_ID === constants.SERVICE_LEVEL_ID.CIBLEX_PRE_09 ||
                      parcel.Service_Level_ID === constants.SERVICE_LEVEL_ID.CIBLEX_SATURDAY ||
                      parcel.Service_Level_ID === constants.SERVICE_LEVEL_ID.PUDO_CIBLEX ||
                      parcel.Service_Level_ID === constants.SERVICE_LEVEL_ID.STOCKONNECT) {
              linkData.link = 'https://secure.extranet.ciblex.fr/extranet/client/corps.php?module=colis&colis=' + forwarderReference
              linkData.providerName = 'Ciblex'
            } else if (parcel.Service_Level_ID === constants.SERVICE_LEVEL_ID.GEODIS_NET_EXPRESS_SPECIAL ||
                        parcel.Service_Level_ID === constants.SERVICE_LEVEL_ID.GEODIS_FRANCE_EXPRESS) {
              linkData.link = 'http://edesti.com/' + forwarderReference
              linkData.providerName = 'Geodis'
            }
            break

          case constants.COUNTRY_ID.ITALY:
            // *************************************************** ITALY ******************************************************************
            // ITALY => Always TNT
            forwarderReference = this.get_Reference_Text(parcel.References, constants.REFERENCE_TYPE_NAME.FORWARDER_REFERENCE)
            if (forwarderReference !== '') {
              linkData.link = 'http://www.tnt.it/tracking/getTrack?WT=1&ConsigNos=' + forwarderReference
              linkData.providerName = 'Fedex IT'
            }
            break

          case constants.COUNTRY_ID.DENMARK:
            // *************************************************** DENMARK ******************************************************************
            // DENMARK => Always 3D ==> Changed to Jetpak
            forwarderReference = this.get_Reference_Text(parcel.References, constants.REFERENCE_TYPE_NAME.BARCODE)
            if (forwarderReference !== '') {
              linkData.link = 'http://portal-opt.jetpak.com/opter/tt/?keyword=' + forwarderReference
              linkData.providerName = 'Jetpak DK'
            }
            break

          case constants.COUNTRY_ID.SWEDEN:
            // *************************************************** SWEDEN ******************************************************************
            // SWEDEN => Jetpak
            if (typeof parcel.Providers === 'string' && parcel.Providers.toLowerCase().trim() === constants.PROVIDER_NAME.JETPAK_SE.toLowerCase().trim()) {
              counterNumber = this.get_Reference_Text(parcel.References, constants.REFERENCE_TYPE_NAME.FORWARDER_TRACKING_REFERENCE)

              linkData.link = 'https://my.jetpak.com/track/csm/' + counterNumber
              linkData.providerName = 'Jetpak SE'
            } else if (typeof parcel.Providers === 'object' && parcel.Providers[0].Provider_ID === constants.PROVIDER_ID.JETPAK_SE) {
              counterNumber = this.get_Reference_Text(parcel.References, constants.REFERENCE_TYPE_NAME.FORWARDER_TRACKING_REFERENCE)

              linkData.link = 'https://my.jetpak.com/track/csm/' + counterNumber
              linkData.providerName = 'Jetpak SE'
            } else if (parcel.Customer_ID === constants.CUSTOMER_ID.FUJITSU ||
                parcel.Customer_ID === constants.CUSTOMER_ID.FUJITSU_TMS) {
              // DANX
              forwarderReference = this.get_Reference_Text(parcel.References, constants.REFERENCE_TYPE_NAME.FORWARDER_REFERENCE)
              if (forwarderReference !== '') {
                linkData.link = 'http://danx.se/Tracking/TraceSearchFast?Barcode=' + forwarderReference
                linkData.providerName = 'DanX'
              }
            } else {
              // TNT NORDICS

              forwarderReference = this.get_Reference_Text(parcel.References, constants.REFERENCE_TYPE_NAME.FORWARDER_REFERENCE)
              if (forwarderReference !== '') {
                linkData.link = 'https://www.tnt.com/express/en_gb/site/shipping-tools/tracking.html?utm_redirect=en_gc_local&cons=' + forwarderReference + '&searchType=CON&source=home_widget'
                linkData.providerName = 'Fedex SE'
              }
            }
            break

          case constants.COUNTRY_ID.NORWAY:
            // *************************************************** NORWAY ******************************************************************
            // NORWAY => Jetpak
            forwarderReference = this.get_Reference_Text(parcel.References, constants.REFERENCE_TYPE_NAME.FORWARDER_TRACKING_REFERENCE)
            if (forwarderReference !== '') {
              linkData.link = 'https://my.jetpak.com/track/csm/' + forwarderReference
              linkData.providerName = 'Jetpak NO'
            }
            break

          case constants.COUNTRY_ID.FINLAND:
            // *************************************************** FINLAND ******************************************************************
            // FINLAND => DanX
            forwarderReference = this.get_Reference_Text(parcel.References, constants.REFERENCE_TYPE_NAME.FORWARDER_REFERENCE)
            if (forwarderReference !== '') {
              linkData.link = 'http://danx.se/Tracking/TraceSearchFast?Barcode=' + forwarderReference
              linkData.providerName = 'DanX'
            }
            break

          case constants.COUNTRY_ID.SPAIN:
          case constants.COUNTRY_ID.PORTUGAL:
          case constants.COUNTRY_ID.CANARY_ISLANDS:
            // *************************************************** SPAIN PORTUGAL AND CANARY ISLANDS ***************************************
            // SPAIN => Nacex if DHL Roche
            if (parcel.Customer_ID === constants.CUSTOMER_ID.DHL_ROCHE) {
              counterNumber = this.get_Reference_Text(parcel.References, constants.REFERENCE_TYPE_NAME.COUNTER_NUMBER)

              linkData.link = 'https://www.nacex.es/seguimientoFormularioExterno.do?intref=' + counterNumber + '&intnumcli=2800/656&intcliv=c'
              linkData.providerName = 'Nacex'
            }
            break

          case constants.COUNTRY_ID.UK:
          case constants.COUNTRY_ID.IRELAND:
          case constants.COUNTRY_ID.JERSEY:
          case constants.COUNTRY_ID.ISLE_OF_MAN:
          case constants.COUNTRY_ID.GUERNSEY:
            // *************************************************** UK and IRELAND ***************************************
            // UK and Ireland => TVS Rico & ByBox
            if (parcel.Customer_ID === constants.CUSTOMER_ID.SIEMENS_HEALTHCARE || parcel.Customer_ID === constants.CUSTOMER_ID.SIEMENS_DIAGNOSTICS || parcel.Customer_ID === constants.CUSTOMER_ID.SIEMENS_DOMESTIC) {
              if (parcel.Providers !== undefined) {
                if (typeof parcel.Providers === 'string' && parcel.Providers.toLowerCase().trim() === constants.PROVIDER_NAME.RICO.toLowerCase().trim()) {
                  counterNumber = this.get_Reference_Text(parcel.References, constants.REFERENCE_TYPE_NAME.PICKUP_REFERENCE)

                  linkData.link = 'https://courierservices.tvsscs.com/aci/net/#!/docket/track?tracking_ref=NCC446A-' + counterNumber
                  linkData.providerName = 'TVS Rico'
                } else if (typeof parcel.Providers === 'string' && parcel.Providers.toLowerCase().trim() === constants.PROVIDER_NAME.BYBOX.toLowerCase().trim()) {
                  counterNumber = this.get_Reference_Text(parcel.References, constants.REFERENCE_TYPE_NAME.FORWARDER_REFERENCE)
                  var serviceOrder = this.get_Reference_Text(parcel.References, constants.REFERENCE_TYPE_NAME.SERVICE_ORDER)
                  serviceOrder = serviceOrder.replaceAll(':', '').trim()
                  linkData.link = 'https://secure.bybox.com/trackmyparcel/'+ counterNumber + '/' + serviceOrder
                  linkData.providerName = 'ByBox'
                } else if (typeof parcel.Providers === 'object' && parcel.Providers[0].Provider_ID === constants.PROVIDER_ID.RICO) {
                  counterNumber = this.get_Reference_Text(parcel.References, constants.REFERENCE_TYPE_NAME.PICKUP_REFERENCE)

                  linkData.link = 'https://courierservices.tvsscs.com/aci/net/#!/docket/track?tracking_ref=NCC446A-' + counterNumber
                  linkData.providerName = 'TVS Rico'
                } else if (typeof parcel.Providers === 'object' && parcel.Providers[0].Provider_ID === constants.PROVIDER_ID.BYBOX) {
                  counterNumber = this.get_Reference_Text(parcel.References, constants.REFERENCE_TYPE_NAME.FORWARDER_REFERENCE)
                  var service_Order = this.get_Reference_Text(parcel.References, constants.REFERENCE_TYPE_NAME.SERVICE_ORDER)
                  service_Order = service_Order.replaceAll(':', '').trim()
                  linkData.link = 'https://secure.bybox.com/trackmyparcel/'+ counterNumber + '/' + service_Order
                  linkData.providerName = 'ByBox'
                }
              }
            } else if (parcel.Customer_ID === constants.CUSTOMER_ID.SIEMENS_RICO) {
              counterNumber = this.get_Reference_Text(parcel.References, constants.REFERENCE_TYPE_NAME.PICKUP_REFERENCE)

              linkData.link = 'https://courierservices.tvsscs.com/aci/net/#!/docket/track?tracking_ref=NCC446A-' + counterNumber
              linkData.providerName = 'TVS Rico'
            } else {
              linkData.link = ''
              linkData.providerName = ''
            }

            break

          default:
            // No link available
            break
        }
      } else {
        // ************************************************** RETURN PARCELS **********************************************
        if (parcel.Country_ID === constants.COUNTRY_ID.FRANCE) {
          var lm2sRexEx = RegExp('^FA[0-9]{3}[A-Z][0-9]{7}DR$')
          var chronoPostRegEx = RegExp('^EE[0-9]{9}FR$')
          var referenceToCheck = this.get_Reference_Text(parcel.References, constants.REFERENCE_TYPE_NAME.FORWARDER_REFERENCE)
          if (!referenceToCheck && referenceToCheck.length === 0) {
            referenceToCheck = this.get_Reference_Text(parcel.References, constants.REFERENCE_TYPE_NAME.COUNTER_NUMBER)
          }
          if (lm2sRexEx.test(referenceToCheck)) {
            linkData.link = 'http://lmline.lm2s.fr/pudo/barcode/' + referenceToCheck
            linkData.providerName = 'LM2S'
          } else if (chronoPostRegEx.test(referenceToCheck)) {
            linkData.link = 'http://www.chronopost.fr/tracking-no-cms/suivi-page?listeNumerosLT=' + referenceToCheck + '&langue=en_GB&pod=true'
            linkData.providerName = 'Chronopost'
          }
        }
        if (parcel.Country_ID === constants.COUNTRY_ID.UK || parcel.Country_ID === constants.COUNTRY_ID.IRELAND) {
          if (parcel.Customer_ID === constants.CUSTOMER_ID.SIEMENS_HEALTHCARE || parcel.Customer_ID === constants.CUSTOMER_ID.SIEMENS_DIAGNOSTICS || parcel.Customer_ID === constants.CUSTOMER_ID.SIEMENS_DOMESTIC) {
            if (parcel.Providers !== undefined) {
              if (typeof parcel.Providers === 'string' && parcel.Providers.toLowerCase().trim() === constants.PROVIDER_NAME.RICO.toLowerCase().trim()) {
                counterNumber = this.get_Reference_Text(parcel.References, constants.REFERENCE_TYPE_NAME.PICKUP_REFERENCE)

                linkData.link = 'https://courierservices.tvsscs.com/aci/net/#!/docket/track?tracking_ref=NCC446B-' + counterNumber
                linkData.providerName = 'TVS Rico'
              } else if (typeof parcel.Providers === 'object' && parcel.Providers[0].Provider_ID === constants.PROVIDER_ID.RICO) {
                counterNumber = this.get_Reference_Text(parcel.References, constants.REFERENCE_TYPE_NAME.PICKUP_REFERENCE)

                linkData.link = 'https://courierservices.tvsscs.com/aci/net/#!/docket/track?tracking_ref=NCC446B-' + counterNumber
                linkData.providerName = 'TVS Rico'
              }
            }
          }
        }
      }
      return linkData
    },

    /// Get the reference text from a list of references based on the reference_name
    get_Reference_Text: function (references, referenceTypeName) {
      for (var i in references) {
        if (references[i].Reference_Type === referenceTypeName) {
          return references[i].Reference_Text
        }
      }
      return ''
    },
    getFromLocalstorage: function (name) {
      try {
        return JSON.parse(window.localStorage.getItem(name))
      } catch (e) {
        return null
      }
    }
  }
}
</script>
